import React, { useEffect, useState } from 'react';
import { DocumentListPotentialClients } from '../../Components/PotentialClients/DocumentList';
import {
  DocumentationStatusValidation,
  StepOne,
} from '../../types/PrekapiDocuments/PrekapiDocuments';
import { TableWarrantyPhotos } from '../../Components/PotentialClients/WarrantyPhotos/TableWarrantyPhotos';
import { set } from 'lodash';

interface WarrantyPhotosSectionProps {
  stepOne?: StepOne;
  claimId?: string;
  clientId?: string;
  setDataSteps: (steps?: DocumentationStatusValidation) => void;
}

export const WarrantyPhotosSection = ({
  stepOne,
  claimId,
  clientId,
  setDataSteps,
}: WarrantyPhotosSectionProps) => {
  const [isOnReview, setIsOnReview] = useState(false);
  const [showReviewButton, setShowReviewButton] = useState(true);

  return (
    <DocumentListPotentialClients
      title='Paso 1: Fotografias de la Garantía'
      onReview={setIsOnReview}
      showReview={showReviewButton}
    >
      <TableWarrantyPhotos
        stepOne={stepOne}
        isOnReview={isOnReview}
        claimId={claimId}
        clientId={clientId}
        setDataSteps={setDataSteps}
        handleShow={() => setShowReviewButton(false)}
      />
    </DocumentListPotentialClients>
  );
};
